import React from "react";
import styles from "./NewDatabaseModa.module.scss";
import ExitIcon from "../../../../assets/icons/ExitIcon";
import CustomButton from "../../../CustomButton/CustomButton";
import CustomInput from "../../../CustomInput/CustomInput";
import { useTranslation } from "react-i18next";

const NewDatabaseModal = ({
  setIsModalOpen,
  databaseData,
  setDataBaseData,
}) => {
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setDataBaseData(null);
    setIsModalOpen(false);
  };

  return (
    <div className={styles.newDatabaseModal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{t("newDatabaseModal.title")}</h2>
          <ExitIcon onClick={handleCloseModal} />
        </div>
        <CustomInput
          label={t("newDatabaseModal.databaseNameLabel")}
          placeholder={t("newDatabaseModal.databaseNamePlaceholder")}
          value={databaseData?.name || null}
        />
        <div className={styles.modalInputContainer}>
          <label htmlFor="" className={styles.label}>
            {t("newDatabaseModal.descriptionLabel")}
          </label>
          <textarea
            className={styles.textarea}
            value={databaseData?.description || null}
            name=""
            id=""
          ></textarea>
        </div>
        <div className={styles.modalFooter}>
          <CustomButton onClick={handleCloseModal}>
            {t("newDatabaseModal.cancelButton")}
          </CustomButton>
          <CustomButton blue>{t("newDatabaseModal.addButton")}</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default NewDatabaseModal;
